import { formatToTimeZone } from 'date-fns-timezone';

const RESOURCE_TIME_ZONE = 'Europe/Stockholm';

export const mapDataForClient = (item) => {
  const fullDate = new Date(item?.date);
  let startHours = '';
  let minutes = '';
  let endHours = '';
  let endDateObj = null;

  if (!Number.isNaN(fullDate)) {
    startHours = formatToTimeZone(fullDate, 'HH', { timeZone: RESOURCE_TIME_ZONE });
    minutes = formatToTimeZone(fullDate, 'mm', { timeZone: RESOURCE_TIME_ZONE });
    endHours = (Number(startHours) + Number(item?.duration?.hours)).toString().padStart(2, '0');
  }

  if (item?.duration?.days) {
    endDateObj = new Date(fullDate);
    endDateObj.setDate(endDateObj.getDate() + item?.duration?.days);
  }

  return {
    id: item?.id,
    duration: item?.duration,
    resourceId: item?.resourceId,
    confirmed: item?.confirmed,
    from: `${startHours}.${minutes}`,
    to: `${endHours}.${minutes}`,
    fullDate,
    fullEndDate: endDateObj,
  };
};
